import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';

import { PropTypes } from 'prop-types';

import './frontComparison.scss';

import productFeatures from '../utils/dataTableValues/productFeatures.json';
import ProfessionalandHardware from '../utils/dataTableValues/professionalandHardware.json';
import news from '../utils/dataTableValues/Entertainment/news.json';
import interactive from '../utils/dataTableValues/Entertainment/interactive.json';
import videoChannels from '../utils/dataTableValues/Entertainment/videoChannels.json';
import premiumSports from '../utils/dataTableValues/Entertainment/premiumSports.json';

import FrontComparisonTable from './FrontComparisonTable';
import useWindowDimensions from '../hooks/useWindowDimensions';

const minScreenSize = 700;

function FrontComparison({ data, period }) {
  const [viewMoreTables, setViewMoreTables] = useState(false);

  const { width } = useWindowDimensions();

  return (
    <div id="Comparison">
      <div className="container">
        <div id="header">
          <div className="grid header">
            <div className="flex flex-column justify-content-start">
              <h2 className="title">Compare Plans</h2>
            </div>
          </div>
        </div>
        <div className="comparisonContainer">
          <div id="card-container" className="card">
            <div className="flex justify-content-around plan-section">
              <div className="col-3">
                <div className="pricing-title">
                  <h3>Plans</h3>
                </div>
              </div>
              <div className="col-1 my-3 flex align-items-center">
                <div className="content_box flex flex-column justify-content-flex-start">
                  <p className="card-title">Starter</p>
                  <div className="price">{data ? <span>${data.starter[period].price}/mo</span> : <span>Loading...</span>}</div>
                  <Button
                    className="btn-white"
                    label="Get a Demo"
                    onClick={() => {
                      window.location.href = `https://www.upshow.tv/get-a-demo/`;
                    }}
                  />
                </div>
                {width >= minScreenSize ? <Divider layout="vertical" /> : null}
              </div>
              <div className="col-1 my-3 flex align-items-center">
                <div className="content_box flex flex-column justify-content-flex-start">
                  <p className="card-title">{width >= minScreenSize ? 'Professional' : 'Prof'}</p>
                  <div className="price">
                    {data ? <span>${data.professional[period].price}/mo</span> : <span>Loading...</span>}
                  </div>
                  <Button
                    className="btn-white"
                    label="Get a Demo"
                    onClick={() => {
                      window.location.href = `https://www.upshow.tv/get-a-demo/`;
                    }}
                  />
                </div>
                {width >= minScreenSize ? <Divider layout="vertical" /> : null}
              </div>
              <div className="col-1 my-3 flex align-items-center">
                <div className="content_box flex flex-column justify-content-flex-start">
                  <p className="card-title">Branded Digital Network</p>
                  <div className="price enterprise">
                    <span>{width >= minScreenSize ? 'Get a Quote' : 'Get Quote'}</span>
                  </div>
                  <Button
                    className="btn-white"
                    label="Get a Demo"
                    onClick={() => {
                      window.location.href = `https://www.upshow.tv/get-a-demo/`;
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="table-section">
            <div className="datatable-templating-demo">
              <summary>
                <div>
                  <FrontComparisonTable data={productFeatures.productFeatures} title={productFeatures.title} />
                </div>
                <div className="datatable-templating-demo">
                  <div>
                    <FrontComparisonTable data={news.dataNews} title={news.title} header={news.header} />

                    <FrontComparisonTable data={interactive.dataInteractive} header={interactive.header} />

                    <FrontComparisonTable data={videoChannels.dataChannels} header={videoChannels.header} />

                    <FrontComparisonTable data={premiumSports.dataSports} header={premiumSports.header} />
                  </div>
                </div>
              </summary>
              {viewMoreTables ? (
                <div id="collapsible" className="collapse">
                  <div className="datatable-templating-demo">
                    <div>
                      <FrontComparisonTable
                        data={ProfessionalandHardware.ProfessionalandHardware}
                        title={ProfessionalandHardware.title}
                      />
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <div className="view_more p-d-flex p-jc-center p-mt-5">
          <Button
            className="btn-white"
            label={viewMoreTables ? 'View Less' : 'View More'}
            onClick={() => setViewMoreTables(!viewMoreTables)}
          />
        </div>
      </div>
    </div>
  );
}

FrontComparison.propTypes = {
  data: PropTypes.any,
  period: PropTypes.string.isRequired,
};
FrontComparison.defaultProps = {
  data: undefined,
};

export default FrontComparison;
